var map = {
	"./en/billing.json": 6224,
	"./en/endpoints.json": 1652,
	"./en/forget.json": 1516,
	"./en/general.json": 8259,
	"./en/login.json": 7366,
	"./en/login/mfa.json": 9782,
	"./en/logs.json": 7011,
	"./en/navigation.json": 6134,
	"./en/oauth/authorize.json": 6462,
	"./en/register.json": 6900,
	"./en/reset.json": 403,
	"./en/settings.json": 1913,
	"./en/team.json": 5163,
	"./en/verify-email.json": 9044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540;